<template>
  <div v-if="userRoles">
    <header class="base__header" :class="{ 'justify-content-center': !access }">
      <h5 class="text-nowrap" :class="{ 'base__header__title-left': !access }">
        База знаний
      </h5>
      <div class="header__tab tablet d-none d-lg-flex">
        <p
          :class="{ 'tab-active': role.active === true }"
          v-for="role in filterRoles"
          :key="role.id"
          @click="activeRole(role.text)"
        >
          {{ role.text }}
        </p>
      </div>
      <b-button
        pill
        class="btn-lg btn-theme-inverse pad-top-10 pad-bot-10 text-nowrap"
        v-if="access"
        v-b-modal.add-link
        >Добавить ссылку</b-button
      >
    </header>
    <main>
      <v-select
        class="custom-style-select w-100 d-lg-none mar-bot-20 bg-light background-select"
        :value="selectedRole"
        :options="filterRoles"
        @input="activeRole"
        :clearable="false"
        label="text"
      ></v-select>
      <div class="row">
        <div class="col-md-6 col-xs-12">
          <card
            :lists="filterCategory"
            @getData="getDataItem"
            @removeData="getDataForRemove"
          />
        </div>
        <div class="col-md-6 col-xs-12">
          <card
            :lists="filterAttachCategory"
            @getData="getDataItem"
            @removeData="getDataForRemove"
          />
        </div>
      </div>
    </main>
    <b-modal id="add-link" centered hide-header hide-footer content-class="p-4">
      <h4 class="mar-bot-20">Добавить ссылку</h4>
      <b-form-group label="Название" label-for="input-1">
        <b-form-input
          id="input-1"
          type="text"
          name="Название"
          v-model="selectedLink.title"
        ></b-form-input>
      </b-form-group>
      <b-form-group label="Ссылка" label-for="input-2">
        <b-form-input
          id="input-2"
          type="text"
          name="Ссылка"
          v-model="selectedLink.url"
        ></b-form-input>
      </b-form-group>
      <b-form-group label="Роль" label-for="dropdown-1">
        <b-dropdown
          id="dropdown-1"
          :text="selectedLink.roles.toString()"
          block
          menu-class="w-100 p-3"
          class="dropdown-select"
        >
          <form class="form-theme">
            <div class="theme-checkbox" v-for="role in roles" :key="role.id">
              <input
                type="checkbox"
                :value="role.value"
                :id="role.value"
                v-model="selectedLink.roles"
              />
              <label :for="role.value">{{ role.text }}</label>
            </div>
          </form>
        </b-dropdown>
      </b-form-group>
      <b-form-group label="Категория" label-for="dropdown-2">
        <v-select
          class="custom-style-select"
          :options="typesCategories"
          label="text"
          v-model="selectedLink.category"
        ></v-select>
      </b-form-group>
      <b-form-group label="Подкатегория" label-for="dropdown-3">
        <v-select
          class="custom-style-select mar-bot-20"
          :options="typesSubCategories"
          label="text"
          :disabled="!selectedLink.category"
          v-model="selectedLink.subCategory"
        ></v-select>
      </b-form-group>
      <b-button
        class="btn-theme mar-bot-10 mar-right-10"
        :disabled="
          selectedLink.title === '' ||
            selectedLink.url === '' ||
            selectedLink.roles.length === 0 ||
            !selectedLink.category
        "
        @click="addLink()"
        >Добавить</b-button
      >
      <b-button
        class="btn-theme-inverse mar-bot-10"
        @click="$bvModal.hide('add-link')"
        >Закрыть</b-button
      >
    </b-modal>
    <b-modal
      id="edit-category"
      centered
      hide-header
      hide-footer
      content-class="p-4"
    >
      <h4 class="mar-bot-20">Категория</h4>
      <v-select
        class="custom-style-select mar-bot-10"
        :options="typesCategories"
        label="text"
        v-model="selectedItem"
      ></v-select>
      <div class="mar-bot-20">
        <div class="theme-checkbox">
          <input type="checkbox" id="attach" v-model="attach" />
          <label for="attach">Прикрепить</label>
        </div>
      </div>
      <b-button
        class="btn-theme mar-bot-10 mar-right-10"
        @click="editCategory()"
        :disabled="!selectedItem"
        >Сохранить</b-button
      >
      <b-button
        class="btn-theme-inverse mar-bot-10"
        @click="reset('edit-category')"
        >Закрыть</b-button
      >
    </b-modal>
    <b-modal
      id="edit-subcategory"
      content-class="p-4"
      centered
      hide-header
      hide-footer
    >
      <h4 class="mar-bot-20">Подкатегория</h4>
      <v-select
        class="custom-style-select mar-bot-20"
        :options="typesSubCategories"
        label="text"
        v-model="selectedItem"
      ></v-select>
      <b-button
        class="btn-theme mar-bot-10 mar-right-10"
        @click="editSubCategory()"
        :disabled="!selectedItem"
        >Сохранить</b-button
      >
      <b-button
        class="btn-theme-inverse mar-bot-10"
        @click="reset('edit-subcategory')"
        >Закрыть</b-button
      >
    </b-modal>
    <b-modal
      id="delete"
      centered
      size="sm"
      hide-header
      hide-footer
      content-class="p-4"
    >
      <h4 class="mar-bot-30">Точно удалить?</h4>
      <b-button-group>
        <b-button class="btn-danger mar-bot-10 mar-right-10" @click="remove()"
          >Удалить</b-button
        >
        <b-button
          class="btn-theme-inverse mar-bot-10 mar-left-10"
          @click="reset('delete')"
          >Закрыть</b-button
        >
      </b-button-group>
    </b-modal>
    <b-modal
      id="edit-link"
      centered
      hide-header
      hide-footer
      @hidden="reset"
      content-class="p-4"
    >
      <h4 class="mar-bot-20">Редактировать ссылку</h4>
      <b-form-group label="Название" label-for="input-1">
        <b-form-input
          id="input-1"
          type="text"
          name="Название"
          v-model="selectedLink.title"
        ></b-form-input>
      </b-form-group>
      <b-form-group label="Ссылка" label-for="input-2">
        <b-form-input
          id="input-2"
          type="text"
          name="Ссылка"
          v-model="selectedLink.url"
        ></b-form-input>
      </b-form-group>
      <b-form-group label="Роль" label-for="dropdown-1">
        <b-dropdown
          id="dropdown-1"
          :text="selectedLink.roles.toString()"
          block
          menu-class="w-100 pr-3 pl-3 pb-4"
          class="dropdown-select"
        >
          <div class="theme-checkbox" v-for="role in roles" :key="role.id">
            <input
              type="checkbox"
              :value="role.value"
              :id="role.value"
              v-model="selectedLink.roles"
            />
            <label :for="role.value">{{ role.text }}</label>
          </div>
        </b-dropdown>
      </b-form-group>
      <b-form-group label="Категория" label-for="dropdown-2">
        <v-select
          class="custom-style-select"
          :options="typesCategories"
          label="text"
          v-model="selectedLink.category"
        ></v-select>
      </b-form-group>
      <b-form-group label="Подкатегория" label-for="dropdown-3">
        <v-select
          class="custom-style-select mar-bot-20"
          :options="typesSubCategories"
          label="text"
          :disabled="!selectedLink.category"
          v-model="selectedLink.subCategory"
        ></v-select>
      </b-form-group>
      <b-button
        class="btn-theme mar-bot-10 mar-right-10"
        @click="editLink()"
        :disabled="
          selectedLink.title === '' ||
            selectedLink.url === '' ||
            selectedLink.roles.length === 0 ||
            !selectedLink.category
        "
        >Сохранить</b-button
      >
      <b-button class="btn-theme-inverse mar-bot-10" @click="reset('edit-link')"
        >Закрыть</b-button
      >
    </b-modal>
  </div>
</template>
<script>
import { mapGetters, mapActions, mapState } from "vuex";
import Card from "@/components/base/Card.vue";
export default {
  components: {
    Card
  },
  data() {
    return {
      attach: false,
      itemId: null,
      selectedItem: null,
      titleItem: null,
      selectedLink: {
        title: "",
        url: "",
        roles: [],
        category: null,
        subCategory: null
      }
    };
  },
  async created() {
    await this.loadCategories();
    await this.loadSubCategories();
    await this.loadLinks();
    await this.rolesUser();
  },
  computed: {
    ...mapGetters("links", [
      "categories",
      "subCategories",
      "links",
      "roles",
      "selectedRole",
      "typesCategories",
      "typesSubCategories"
    ]),
    ...mapState("user", {
      admin: state => state.data.admin,
      access: state => state.data.access,
      userRoles: state => state.data.role
    }),
    filterRoles() {
      return this.roles.filter(item => this.userRoles.includes(item.id));
    },
    filterAttachCategory() {
      return this.categories.filter(item => item.attach);
    },
    filterCategory() {
      return this.categories.filter(item => !item.attach);
    }
  },
  methods: {
    ...mapActions("links", [
      "loadCategories",
      "loadSubCategories",
      "loadLinks",
      "setRole",
      "setLink",
      "updateCategories",
      "updateSubCategories",
      "updateLink",
      "removeElement"
    ]),
    getDataItem(item) {
      if (item.title === "link") {
        this.itemId = item.data.id;
        this.selectedLink.title = item.data.title;
        this.selectedLink.url = item.data.url;
        this.selectedLink.roles = item.data.roles;
        this.selectedLink.category = this.categories.find(
          element => element.id === item.data.cat_id
        );
        this.selectedLink.subCategory = this.subCategories.find(
          element => element.id === item.data.subcat_id
        );
      } else if (item.title === "item") {
        this.itemId = item.data.id;
        this.selectedItem = item.data.text;
      }
    },
    getDataForRemove(item) {
      this.itemId = item.id;
      this.titleItem = item.title;
    },
    editCategory() {
      this.updateCategories({
        id: this.itemId,
        text: this.selectedItem.text
          ? this.selectedItem.text
          : this.selectedItem,
        attach: this.attach
      });
      this.reset("edit-category");
    },
    editSubCategory() {
      this.updateSubCategories({
        id: this.itemId,
        text: this.selectedItem.text
          ? this.selectedItem.text
          : this.selectedItem
      });
      this.reset("edit-subcategory");
    },
    editLink() {
      this.updateLink({
        id: this.itemId,
        title: this.selectedLink.title,
        url: this.selectedLink.url,
        roles: this.selectedLink.roles,
        cat_id: this.selectedLink.category.id,
        subcat_id: this.selectedLink.subCategory
          ? this.selectedLink.subCategory.id
          : null,
        show: true
      });
      this.reset("edit-link");
    },
    addLink() {
      const id =
        this.links.length > 0 ? this.links[this.links.length - 1].id + 1 : 1;
      this.setLink({
        id: id,
        title: this.selectedLink.title,
        url: this.selectedLink.url,
        roles: this.selectedLink.roles,
        cat_id: this.selectedLink.category.id,
        subcat_id: this.selectedLink.subCategory
          ? this.selectedLink.subCategory.id
          : null,
        show: true
      });
      this.reset("add-link");
    },
    rolesUser() {
      this.roles.some(item => {
        if (item.id === this.userRoles[0]) {
          item.active = true;
          this.setRole(item.text);
        }
      });
      this.activeRole(this.selectedRole);
    },
    activeRole(role) {
      if (typeof role === "object") {
        role = role.text;
      }
      this.setRole(role);
      this.roles.forEach(element => {
        if (element.text === this.selectedRole) {
          element.active = true;
        } else {
          element.active = false;
        }
      });
      this.filteredLinks();
    },
    filteredLinks() {
      this.links.some(el => {
        el.show = el.roles.includes(this.selectedRole);
      });
    },
    reset(name) {
      this.selectedLink = {
        title: "",
        url: "",
        roles: [],
        category: null,
        subCategory: null
      };
      this.itemId = null;
      this.selectedItem = null;
      this.titleItem = null;
      this.attach = false;
      this.$bvModal.hide(name);
    },
    remove() {
      this.removeElement({
        id: this.itemId,
        name: this.titleItem
      });
      this.$bvModal.hide("delete");
    }
  },
  watch: {
    links(val) {
      if (val) {
        this.filteredLinks();
      }
    }
  }
};
</script>
<style>
.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}
.background-select .vs__dropdown-toggle {
  background: white;
}
</style>
